export const COTW_PATH = '/comp-of-the-week';
export const COTW_LINK = { label: 'Comp of the Week', path: COTW_PATH };

/** Site-level publication state. Missing config is intentionally unpublished. */
export const normalizeCotwVisibility = (config) =>
  config?.compOfTheWeek?.published === true;

export const isCotwLink = (link) => {
  const path =
    typeof link?.path === 'string'
      ? link.path.trim().split(/[?#]/, 1)[0].replace(/\/+$/, '')
      : '';
  const label = typeof link?.label === 'string' ? link.label.trim() : '';
  return path === COTW_PATH || /^comp\s+of\s+the\s+week$/i.test(label);
};

/** Remove stale links, then add exactly one canonical header link when live. */
export const sanitizeCotwLinks = (links, published) => {
  const withoutCotw = Array.isArray(links) ? links.filter((link) => !isCotwLink(link)) : [];
  return published ? [...withoutCotw, { ...COTW_LINK }] : withoutCotw;
};
